<template>
  <main class="flex h-screen overflow-hidden">
    <UiSidebar />
    <div class="h-screen w-full bg-[var(--main-background)] px-4 pb-4 pt-14 md:pt-0 ">
      <div class="fixed top-4 right-4 z-50 pointer-events-auto">
        <UiColorMode />
      </div>
      <slot />
    </div>
  </main>
</template>
